import type {
  AdminImportMappingDeleteRequest,
  AdminImportMappingItemDto,
  AdminImportMappingSaveRequest,
  AdminListDictionaryPropertiesRequest,
  AdminListDictionaryPropertiesResponse,
} from '@/venit/services/model/techpubs-cms';
import axios, { type AxiosResponse } from 'axios';

export default class ImportPropertyMappingService {
  public list(request: AdminListDictionaryPropertiesRequest): Promise<AxiosResponse<AdminListDictionaryPropertiesResponse>> {
    return axios.post<AdminListDictionaryPropertiesResponse>('/api/admin/dict/import-properties/list', request);
  }

  public save(request: AdminImportMappingSaveRequest): Promise<AxiosResponse<AdminImportMappingItemDto>> {
    return axios.post<AdminImportMappingItemDto>('/api/admin/dict/import-properties/save', request);
  }

  public delete(request: AdminImportMappingDeleteRequest): Promise<AxiosResponse<void>> {
    return axios.post<void>('/api/admin/dict/import-properties/delete', request);
  }
}
